import React from "react";
import "./Homepage.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
const Homepage = () => {
  const navigate = useNavigate();
  return (
    <div className="homepage">
      <div className="first">
        <MDBCard style={{ maxWidth: "30rem" }}>
          <MDBCardBody>
            <MDBCardTitle>سایت آموزش زبان</MDBCardTitle>
            <MDBCardText>این سایت یک نمونه ی دمو از یک پروژه کامل است</MDBCardText>
            <MDBCardText>بخش فرانت : ری اکت / بخش بک اند : پایتون ، جنگو</MDBCardText>
            <MDBCardText>ابتدا نقش خود را انتخاب کنید </MDBCardText>
            <MDBBtn onClick={() => navigate("/Teacher")}>معلم</MDBBtn>
            <MDBBtn onClick={() => navigate("/Studenthomepage")}>زبان آموز</MDBBtn>
          </MDBCardBody>
        </MDBCard>
      </div>
      <div className="first">
        <MDBCard style={{ maxWidth: "30rem" }}>
          <MDBCardBody>
            <MDBCardTitle>سایت کافه لند</MDBCardTitle>
            <MDBCardText>این سایت یک نمونه ی دمو از یک پروژه کامل است</MDBCardText>
            <MDBCardText>به صورت دمو تماما با ری اکت نوشته شده است</MDBCardText>
            <MDBBtn onClick={() => (window.location.href = "https://cafeland-eg844mtja-arash-pouya.vercel.app/")}>ورود به سایت</MDBBtn>
          </MDBCardBody>
        </MDBCard>
      </div>
    </div>
  );
};

export default Homepage;
